package api.dataclasses.inbound

import api.interfaces.ICSMarksAllowedFieldParser
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import pages.inbound.InboundDetailPageFieldMappings

@Suppress("ArrayInDataClass")
@Serializable
data class InboundReceiptDetailed(
    @SerialName("RecordId") val recordId: Int,
    @SerialName("Eigenaar") val owner: String,
    @SerialName("Klant") val customer: String,
    @SerialName("Klant_omschrijving") val customerDescription: String,
    @SerialName("Klantreferentie") val customerReference: String,
    @SerialName("Naam") val name: String,
    @SerialName("Adres") val address: String,
    @SerialName("Postcode") val zipCode: String,
    @SerialName("Plaats") val city: String,
    @SerialName("Land") val country: String,
    @SerialName("Emailadres") val email: String,
    @SerialName("Artikelgroep") val articleCategory: String,
    @SerialName("Aantal_Containers") val containerAmount: Double,
    @SerialName("Aantal_ontvangen") val amountReceived: Double,
    @SerialName("Te_ontvangen_aantal") val amountToReceive: Double,
    @SerialName("Eind_datumtijd") val endDateTime: String?,
    @SerialName("Invoerdatumtijd") val inputDateTime: String?,
    @SerialName("Referentie_extern") val externalReference: String,
    @SerialName("Referentie_intern") val internalReference: String,
    @SerialName("Special") val special: Boolean,
    @SerialName("Statusomschrijving") val statusDescription: String,
    @SerialName("Toelichting") val explanation: String,
    @SerialName("Webshop") val webShop: Boolean,
    @SerialName("Opdrachttype") val assignmentType: String,

    @SerialName("Fields") override val fields: Array<String>,
    @SerialName("lines") var lines: Array<InboundReceiptLine> = arrayOf()
    ) : ICSMarksAllowedFieldParser
